import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-confirm-email',
  standalone: false,
  templateUrl: './confirm-email.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {
  errorMessage = '';
  constructor(
    private route: ActivatedRoute,
    private usersService: UsersService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email') || '';
    const token = this.route.snapshot.queryParamMap.get('token') || '';
    if (email && token) {
      this.usersService.confirmEmail(email, token).subscribe({
        next: () => {
          this.snackBar.open('Adres e-mail został potwierdzony. Teraz możesz się zalogować.', 'Zamknij', {
            duration: 14000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
          setTimeout(() => this.router.navigate(['/logowanie']), 1000);
        },
        error: () => {
          this.errorMessage = 'Wystąpił problem podczas potwierdzania adresu e-mail. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.';
          this.snackBar.open('Nie udało się potwierdzić adresu e-mail.', 'Zamknij', {
            duration: 4000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      });
    }
  }
}